import React from 'react';

function Copyright() {
  return (
    <div id="copyright">
        <ul><li>© כל הזכויות שמורות לדביר הנדסה ובניה</li></ul>
    </div>
  );
}

export default Copyright;